<template>
  <div>
    <!-- SEARCH BAR -->
    <div class="search-bar-wrapper">
      <b-row no-gutters align-v="center">
        <b-col cols="10">
          <b-form-input v-model="d_searchText" :placeholder="StoreLangTranslation.data['search'][StoreLang] + '...'" @keyup.enter="f_search" class="search-input"/>
        </b-col>

        <b-col cols="1" class="pl-2">
          <b-button :disabled="f_checkEligibleSeacrh()" variant="primary" block @click="f_search()">
            <i class="fa fa-search"></i>
          </b-button>
        </b-col>

        <b-col cols="1" class="pl-2">
          <b-button :disabled="d_searchLoading" variant="danger" block @click="f_deleteSearchData()">
            <i class="fa fa-trash"></i>
          </b-button>
        </b-col>
      </b-row>

      <b-row no-gutters align-v="center" class="search-from-row" style="margin-top: 5px;">
        <b-col lg="2" sm="12" class="pl-2 label-col">
          Search from:
        </b-col>

        <b-col lg="8" sm="12" class="pl-2" style="text-align: center;">
          <button
            v-if="!p_searchType || p_searchType === 'profile'"
            class="search-toggle profile"
            :class="{ active: d_searchFrom.profile === '1' }"
            style="margin: 0px 5px;"
            @click="f_changeSearchFromInput('profile')">
            {{ StoreLangTranslation.data['search_profile'][StoreLang] }}
          </button>

          <button
            v-if="StoreFrontendSettings.data.are_shop_pages_active == '1' && (!p_searchType || p_searchType === 'bundle')"
            class="search-toggle bundle"
            :class="{ active: d_searchFrom.bundle === '1' }"
            style="margin: 0px 5px;"
            @click="f_changeSearchFromInput('bundle')">
            {{ StoreLangTranslation.data['search_bundle'][StoreLang] }}
          </button>

          <button
            v-if="!p_searchType || p_searchType === 'webunit'"
            class="search-toggle webunit"
            :class="{ active: d_searchFrom.webunit === '1' }"
            style="margin: 0px 5px;"
            @click="f_changeSearchFromInput('webunit')">
            {{ StoreLangTranslation.data['search_webunit'][StoreLang] }}
          </button>
        </b-col>

        <b-col lg="2" sm="12"></b-col>
      </b-row>
    </div>

    <!-- CONTENT -->
    <div class="search-content">
      <template v-if="d_searchLoading">
        <div class="text-center my-5">
          <b-spinner variant="primary" class="mb-2"></b-spinner>
          <div class="text-muted">Searching...</div>
        </div>
      </template>

      <template v-else-if="d_searchResults.length > 0">
        <template v-for="(search_result, index) in d_searchResults">
          <div v-if="search_result.result_type && search_result.result_type === 'profile'" :key="index" class="search-result-item">
            <i class="fa fa-user search-result-icon"></i>

            <span class="search-result-text" @click="f_goToProfileLink(search_result.result_data.link_key_list)">
              {{ search_result.result_data.label }}
            </span>

            <a :href="f_getProfileLink(search_result.result_data.link_key_list)" target="_blank" class="search-result-external">
              <i class="fa fa-external-link"></i>
            </a>
          </div>
          <div v-else-if="search_result.result_type && search_result.result_type === 'dataset'" :key="index" class="search-result-item">
            <i class="fa fa-table search-result-icon"></i>

            <span class="search-result-text" @click="f_goToDatasetLink(search_result.result_data.link_key_list)">
              {{ search_result.result_data.label[StoreLang] }}
            </span>

            <a :href="f_getDatasetLink(search_result.result_data.link_key_list)" target="_blank" class="search-result-external">
              <i class="fa fa-external-link"></i>
            </a>
          </div>
          <div v-else-if="search_result.result_type && search_result.result_type === 'bundle'" :key="index" class="search-result-item">
            <i class="fa fa-tag search-result-icon"></i>

            <span class="search-result-text" @click="f_goToBundleLink(search_result.result_data.link_key_list)">
              {{ search_result.result_data.label[StoreLang] }}
            </span>

            <a :href="f_getBundleLink(search_result.result_data.link_key_list)" target="_blank" class="search-result-external">
              <i class="fa fa-external-link"></i>
            </a>
          </div>
          <div v-else-if="search_result.result_type && search_result.result_type === 'webunit'" :key="index" class="search-result-item">
            <i class="fa fa-globe search-result-icon"></i>

            <div class="search-result-text" @click="f_goToWebunitLink(search_result.result_data.route_path)" v-html="search_result.result_data.label[StoreLang]">
              <!-- {{ search_result.result_data.label.lang[StoreLang] }} -->
            </div>

            <a :href="f_getWebunitLink(search_result.result_data.route_path)" target="_blank" class="search-result-external">
              <i class="fa fa-external-link"></i>
            </a>
            <br/>
          </div>

          <!-- <div v-if="false && search_result.result_data && search_result.result_data.content && search_result.result_data.content[StoreLang]" style="margin: 0px 10px;">
            <p class="search-result-text" v-html="search_result.result_data.content[StoreLang]">
            </p>
          </div> -->

          <div v-if="search_result.result_data && search_result.result_data.parameter" style="margin: 0px 10px;">
            <b-row>
              <b-col cols="2">
                <strong>{{ d_paramMatch[search_result.result_type][search_result.result_data.search_field][StoreLang] }}</strong>
              </b-col>
              <b-col cols="10">
                <p class="search-result-text" v-html="search_result.result_data.parameter">
                </p>
              </b-col>
            </b-row>
          </div>

          <hr/>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { ServiceFunctions } from '@/wam/modules/service';
import { mapGetters } from 'vuex';
export default {
  name: 'Search',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreDevice: 'StoreDevice',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  props: {
    p_searchType: {
      type: String,
      required: false
    },
  },
  data () {
    return {
      d_searchText: '',
      d_searchLoading: false,
      d_searchResults: [],
      d_searchFrom: {
        'profile': '1',
        'bundle': '1',
        'webunit': '1'
      },
      d_paramMatch: {
        'bundle': {
          '1': {'tr': 'ad', 'en': 'name'},
          '38': {'tr': 'çeşitli değişkenler', 'en': 'various variables'},
          '39': {'tr': 'Dataset hakkında', 'en': 'About dataset'},
          '48': {'tr': 'dergi adı', 'en': 'journal name'},
          '49': {'tr': 'makale başlığı', 'en': 'article title'},
          '50': {'tr': 'Makale linki', 'en': 'Article link'},
          '58': {'tr': 'yazarın adı', 'en': 'author firstname'},
          '59': {'tr': 'yazarın soyadı', 'en': 'author lastname'},
          '67': {'tr': 'makale yazarının adı', 'en': 'article author firstname'},
          '68': {'tr': 'makale yazarının soyadı', 'en': 'article author lastname'},
        },
        'dataset': {
          '1': {'tr': 'ad', 'en': 'name'},
          '38': {'tr': 'çeşitli değişkenler', 'en': 'various variables'},
          '39': {'tr': 'Dataset hakkında', 'en': 'About dataset'},
          '48': {'tr': 'dergi adı', 'en': 'journal name'},
          '49': {'tr': 'makale başlığı', 'en': 'article title'},
          '50': {'tr': 'Makale linki', 'en': 'Article link'},
          '58': {'tr': 'yazarın adı', 'en': 'author firstname'},
          '59': {'tr': 'yazarın soyadı', 'en': 'author lastname'},
          '67': {'tr': 'makale yazarının adı', 'en': 'article author firstname'},
          '68': {'tr': 'makale yazarının soyadı', 'en': 'article author lastname'},
        },
        'webunit': {
          '2': {'tr': 'menü açıklaması', 'en': 'menu caption'},
          '8': {'tr': 'sayfa bilgisi açıklaması', 'en': 'page info caption'},
          '10': {'tr': 'sayfa bilgisi detay açıklaması', 'en': 'page info detail caption'},
          '26': {'tr': 'sayfa bilgisi detay notu', 'en': 'page info detail note'},
        },
        'profile': {
          '22': {'tr': 'hakkında not', 'en': 'about note'},
          '1': {'tr': 'ad', 'en': 'firstname'},
          '2': {'tr': 'soyad', 'en': 'lastname'},
          '3': {'tr': 'kullanıcı adı', 'en': 'username'},
        }
      }
    }
  },
  created: function () {
    if (this.p_searchType) {
      this.d_searchFrom = {
        'profile': '0',
        'bundle': '0',
        'webunit': '0'
      };
      if (this.d_searchFrom.hasOwnProperty(this.p_searchType)) {
        this.d_searchFrom[this.p_searchType] = '1';
      }
    } else {
      const storage_last_srch = JSON.parse(localStorage.getItem("last_search"));
      try {
        this.d_searchText = storage_last_srch.search_text;
      } catch {}
      try {
        this.d_searchResults = storage_last_srch.search_results;
      } catch {}
      try {
        this.d_searchFrom = storage_last_srch.search_from;
      } catch {}
    }
  },
  mounted: function () {
    //
  },
  methods: {
    f_checkEligibleSeacrh: function () {
      if (this.d_searchFrom['profile'] == '0' && this.d_searchFrom['bundle'] == '0' && this.d_searchFrom['webunit'] == '0') {
        return true;
      }
      if (!this.d_searchText || this.d_searchText.length < 3) {
        return true;
      }
      return false;
    },
    f_changeSearchFromInput: function (key) {
      // console.log(this.d_searchFrom[key])
      if (this.d_searchFrom[key] === '0') {
        this.d_searchFrom[key] = '1';
      } else {
        this.d_searchFrom[key] = '0';
      }
    },
    f_deleteSearchData: function () {
      this.d_searchText = '';
      this.d_searchResults = [];
      try {
        localStorage.removeItem('last_search');
      } catch {}
    },
    f_goToProfileLink: function (link_key_list) {
      this.d_searchModal = false;
      this.$router.push({ path: this.StoreLangTranslation.data['profile'][this.StoreLang], query: {'u': link_key_list['u']} });
    },
    f_getProfileLink: function (link_key_list) {
      const origin = window.location.origin;
      const newPath = '/' + this.StoreLangTranslation.data['profile'][this.StoreLang] + '?u=' + link_key_list['u'];
      const newUrl = origin + newPath;
      return newUrl;
    },
    f_goToDatasetLink: function (link_key_list) {
      this.d_searchModal = false;
      this.$router.push({ path: 'dataset', query: {'did': link_key_list['did']} });
    },
    f_getDatasetLink: function (link_key_list) {
      const origin = window.location.origin;
      const newPath = '/dataset?did=' + link_key_list['did'];
      const newUrl = origin + newPath;
      return newUrl;
    },
    f_goToBundleLink: function (link_key_list) {
      this.d_searchModal = false;
      this.$router.push({ path: this.StoreLangTranslation.data['product_details_page'][this.StoreLang], query: {'user_shop_client_id': link_key_list['user_shop_client_id'], 'user_shop_bundle_client_id': link_key_list['user_shop_bundle_client_id']} });
    },
    f_getBundleLink: function (link_key_list) {
      const origin = window.location.origin;
      const newPath = '/' + this.StoreLangTranslation.data['product_details_page'][this.StoreLang] + '?user_shop_client_id=' + link_key_list['user_shop_client_id'] + '&user_shop_bundle_client_id=' + link_key_list['user_shop_bundle_client_id'];
      const newUrl = origin + newPath;
      return newUrl;
    },
    f_goToWebunitLink: function (route_path) {
      this.d_searchModal = false;
      this.$router.push({ path: route_path[this.StoreLang], query: {} });
    },
    f_getWebunitLink: function (route_path) {
      const origin = window.location.origin;
      const newPath = '/' + route_path[this.StoreLang];
      const newUrl = origin + newPath;
      return newUrl;
    },
    f_search: function () {
      this.d_searchResults = [];
      let last_search = {
        'search_text': this.d_searchText,
        'search_results': this.d_searchResults,
        'search_from': this.d_searchFrom,
      }
      localStorage.setItem("last_search", JSON.stringify(last_search));
      // console.log(this.d_searchText);
      if (this.d_searchText) {
        this.d_searchLoading = true;
        let query = 'search_text=' + this.d_searchText;
        // query += '&lang=' + this.StoreLang;
        let data = {'search_from': this.d_searchFrom};
        ServiceFunctions.search_text(query, data)
          .then(resp => {
            this.d_searchLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              this.d_searchResults = resp.data.search_result_list;
              let last_search = {
                'search_text': this.d_searchText,
                'search_results': this.d_searchResults,
                'search_from': this.d_searchFrom,
              }
              localStorage.setItem("last_search", JSON.stringify(last_search));
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
  }
}
</script>
